export const urls = {
  kwsHome: 'https://www.kidswebservices.com/en-US',
  kwsTermsOfUse: 'https://www.kidswebservices.com/en-US/terms-of-use',
  kwsPrivacyPolicy: 'https://www.kidswebservices.com/en-US/privacy-policy',
}

export const KWS_SUPPORTED_LANGS = [
  {value: 'en', label: 'English'},
  {value: 'ar', label: 'العربية'},
  {value: 'zh-Hans', label: '简体中文'},
  {value: 'cs', label: 'Čeština'},
  {value: 'nl', label: 'Nederlands'},
  {value: 'tl', label: 'Filipino'},
  {value: 'fr', label: 'Français'},
  {value: 'de', label: 'Deutsch'},
  {value: 'id', label: 'Bahasa Indonesia'},
  {value: 'it', label: 'Italiano'},
  {value: 'ja', label: '日本語'},
  {value: 'ko', label: '한국어'},
  {value: 'pt', label: 'Português'},
  {value: 'pt-BR', label: 'Português (Brasil)'},
  {value: 'ru', label: 'Русский'},
  {value: 'es', label: 'Español'},
  {value: 'tr', label: 'Türkçe'},
  {value: 'th', label: 'ภาษาไทย'},
  {value: 'vi', label: 'Tiếng Việt'},
]
